export let calendarDayOfWeek_Wednesday = "UlgG3d";
export default {calendarDayOfWeek_Wednesday};